module.exports = __webpack_public_path__ + "MGF-logo-with-text2-300x300.jpg?7f169fc2d535e6ff5ad0e18098b79c4b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/MGF-logo-with-text2-300x300.jpg
// module id = 95
// module chunks = 0